import { render, staticRenderFns } from "./NewEmergencyNumberPage.vue?vue&type=template&id=e2f778c4&"
import script from "./NewEmergencyNumberPage.vue?vue&type=script&lang=js&"
export * from "./NewEmergencyNumberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports